import { render, staticRenderFns } from "./UserViewGlobal.vue?vue&type=template&id=650ed320&"
import script from "./UserViewGlobal.vue?vue&type=script&lang=js&"
export * from "./UserViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports